import { render, staticRenderFns } from "./academic_questionType_management.vue?vue&type=template&id=edb42ba0&scoped=true&"
import script from "./academic_questionType_management.vue?vue&type=script&lang=js&"
export * from "./academic_questionType_management.vue?vue&type=script&lang=js&"
import style0 from "./academic_questionType_management.vue?vue&type=style&index=0&id=edb42ba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb42ba0",
  null
  
)

export default component.exports